// Compress + resize ฝั่ง client ก่อน upload
// - max 1024px ด้านยาวสุด (fit-inside, รักษาอัตราส่วน)
// - JPEG quality 0.85
// - re-encode ผ่าน Canvas → EXIF (รวม GPS) ถูก strip อัตโนมัติ

const MAX_DIMENSION = 1024;
const QUALITY = 0.85;

export interface CompressedPhoto {
  blob: Blob;
  fileName: string;
  width: number;
  height: number;
  previewUrl: string; // object URL ใช้แสดง preview
}

export async function compressImage(file: File): Promise<CompressedPhoto> {
  const img = await loadImage(file);
  const { width, height } = fitWithin(img.width, img.height, MAX_DIMENSION);

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('canvas 2d context not available');
  ctx.drawImage(img, 0, 0, width, height);

  const blob: Blob = await new Promise((resolve, reject) =>
    canvas.toBlob(
      (b) => (b ? resolve(b) : reject(new Error('canvas toBlob failed'))),
      'image/jpeg',
      QUALITY,
    ),
  );

  const safeName = file.name.replace(/[^\w.-]/g, '_').slice(0, 40) || 'photo.jpg';
  const fileName = safeName.toLowerCase().endsWith('.jpg')
    ? safeName
    : `${safeName.replace(/\.[^.]+$/u, '')}.jpg`;

  return {
    blob,
    fileName,
    width,
    height,
    previewUrl: URL.createObjectURL(blob),
  };
}

function loadImage(file: File): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('โหลดรูปไม่สำเร็จ'));
    };
    img.src = url;
  });
}

function fitWithin(w: number, h: number, max: number): { width: number; height: number } {
  if (w <= max && h <= max) return { width: w, height: h };
  const ratio = w / h;
  return ratio > 1
    ? { width: max, height: Math.round(max / ratio) }
    : { width: Math.round(max * ratio), height: max };
}
